import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cc from 'classcat';
import { identity } from 'ramda';

import { themes } from '../../lib/themes';
import { getEnvironment } from '../../store/environment/selectors';
import Container from '../Container';
import Link from '../Link';

import styles from './styles.module.scss';

const ErrorDisplay = ({
  heading,
  message,
  errors,
  theme,
  className,
  WB_ENV,
  SUPPORT_EMAIL,
}) => (
  <Container className={cc([styles.container, className])}>
    <h1>{heading}</h1>
    <p className={styles.message}>{message}</p>
    <p className={styles.message}>
      Please try again or contact us at{' '}
      <Link theme={theme} href={`mailto:${SUPPORT_EMAIL}`}>
        {SUPPORT_EMAIL}
      </Link>
    </p>
    {WB_ENV != 'production' &&
      errors?.filter(identity).map?.((error, index) => {
        const stack = error?.stack || error?.meta?.stack;
        return (
          <dl key={index} className={styles.details}>
            <dt>{error.message}</dt>
            <dd className={styles.meta}>
              {!!error?.meta && (
                <div>
                  <ul>
                    <li>
                      <strong>ID:</strong> {error.meta.id}
                    </li>
                    <li>
                      <strong>Code:</strong> {error.meta.code}
                    </li>
                  </ul>
                </div>
              )}
              {!!stack?.length && (
                <ul>
                  {stack?.split('\n').map((line, index) => (
                    <li key={index}>{line}</li>
                  ))}
                </ul>
              )}
            </dd>
          </dl>
        );
      })}
  </Container>
);

ErrorDisplay.propTypes = {
  errors: PropTypes.array,
  theme: PropTypes.oneOf(themes),
  heading: PropTypes.string,
  message: PropTypes.string,
};

ErrorDisplay.defaultProps = {
  theme: 'waybetter',
  heading: 'There was an error',
  message: '',
};

ErrorDisplay.displayName = 'ErrorDisplay';

export default connect((state) => {
  const { WB_ENV, SUPPORT_EMAIL } = getEnvironment(state);
  return { WB_ENV, SUPPORT_EMAIL };
})(ErrorDisplay);
